<template>
	<div
		:class="[
			'c-item-board',
			{ active: active === true },
			{ disabled: processing === true },
		]"
	>
		<div class="c-item-board__inner" @click="onClick">
			<span>
				{{ board.name }}
			</span>
			<span :class="[{ faded: board._count === 0 }]">
				{{ board._count }}
			</span>

			<svg
				v-if="showDropdown"
				:class="`board board-${board.id}`"
				@mousedown.prevent="onDropdownClick(board)"
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12C19 12.5523 19.4477 13 20 13Z"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M4 13C4.55228 13 5 12.5523 5 12C5 11.4477 4.55228 11 4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13Z"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>

			<svg
				v-if="showDragger"
				class="handle"
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9 3C7.89543 3 7 3.89543 7 5C7 6.10457 7.89543 7 9 7C10.1046 7 11 6.10457 11 5C11 3.89543 10.1046 3 9 3Z"
					fill="currentColor"
				/>
				<path
					d="M15 3C13.8954 3 13 3.89543 13 5C13 6.10457 13.8954 7 15 7C16.1046 7 17 6.10457 17 5C17 3.89543 16.1046 3 15 3Z"
					fill="currentColor"
				/>
				<path
					d="M9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10Z"
					fill="currentColor"
				/>
				<path
					d="M15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10Z"
					fill="currentColor"
				/>
				<path
					d="M9 17C7.89543 17 7 17.8954 7 19C7 20.1046 7.89543 21 9 21C10.1046 21 11 20.1046 11 19C11 17.8954 10.1046 17 9 17Z"
					fill="currentColor"
				/>
				<path
					d="M15 17C13.8954 17 13 17.8954 13 19C13 20.1046 13.8954 21 15 21C16.1046 21 17 20.1046 17 19C17 17.8954 16.1046 17 15 17Z"
					fill="currentColor"
				/>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		board: {},
		active: {},
		showDragger: {
			type: Boolean,
			default: true,
		},
		showDropdown: {
			type: Boolean,
			default: true,
		},
		processing: {
			type: Boolean,
			default: false,
		},
	},

	methods: {
		onClick: function (e) {
			let condition = e.target.closest('.handle');
			if (condition) {
				return;
			}

			condition = e.target.closest('.board');
			if (condition) {
				return;
			}

			let board = this.board;
			this.$router.push(`/boards/${board.slug}`).catch((err) => {});
		},
		onDropdownClick: function (board) {
			this.$emit('onBoardDropdownClick', board);
		},
	},
};
</script>

<style lang="scss">
.c-item-board {
	padding: var(--margin-sm) 0;

	&__inner {
		padding: var(--margin);
		padding-left: var(--margin-lg);
		font-size: var(--font-size-xs);
		color: var(--color-button-font);
		background-color: var(--color-bg-96);
		border-radius: var(--border-radius);
		cursor: pointer;

		display: flex;
		align-items: center;

		transition: all var(--transition-time) ease-out;

		box-shadow: inset 0 -1px 1px #00000001, inset 0 1px 1px #ffffff05,
			inset 0 5px 20px 1px #ffffff05, 0 2px 5px #3c42570a, 0 1px 1px #0000000f,
			0 0 0 1px #00000013;

		span {
			&:last-of-type {
				margin-left: auto;
				padding: 2px 4px;
				font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
					'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0,
					'ss04', 'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0,
					'cv03' 0, 'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0,
					'cv10' 0, 'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0,
					'aalt' 0, 'calt', 'ccmp', 'locl', 'kern';
				font-size: var(--font-size-xs);
				line-height: 1;
			}

			&.faded {
				opacity: 0.35;
			}
		}

		svg {
			padding: 2px;

			&.handle {
				cursor: move;
			}
		}

		&:hover,
		&:active {
			background-color: var(--color-bg-95);
		}
	}

	&.active {
		.c-item-board__inner {
			background-color: var(--color-primary);
		}
	}

	&.disabled {
		svg {
			opacity: 0.5;
			pointer-events: none;
		}
	}
}
</style>
